import { render, staticRenderFns } from "./BestaetigenPopup.vue?vue&type=template&id=99fdbf4a&scoped=true&"
import script from "./BestaetigenPopup.vue?vue&type=script&lang=js&"
export * from "./BestaetigenPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fdbf4a",
  null
  
)

export default component.exports